/**
 * Atribuição de origem (first-touch) do candidato.
 *
 * Captura de onde a pessoa chegou (utm_source/ref na URL ou domínio de referência)
 * na primeira visita e guarda na sessão. Usado como `source` da candidatura, pra
 * alimentar o analytics "por origem" no admin. Sem isso, toda candidatura viria
 * com a mesma origem fixa e a métrica seria inútil.
 */

const KEY = "guebly_src";

/** Guarda a origem na sessão (só na primeira vez — first-touch). */
export function captureAttribution() {
  try {
    if (sessionStorage.getItem(KEY)) return;
    const p = new URLSearchParams(window.location.search);
    let src = p.get("utm_source") || p.get("ref") || p.get("source");
    if (!src && document.referrer) {
      try {
        const host = new URL(document.referrer).hostname.replace(/^www\./, "");
        if (host && !host.includes("guebly.com.br")) src = host;
      } catch { /* referrer inválido */ }
    }
    sessionStorage.setItem(KEY, (src || "direto").toLowerCase().slice(0, 60));
  } catch { /* sessionStorage indisponível */ }
}

/** Lê a origem capturada (padrão: "direto"). */
export function getAttribution() {
  try { return sessionStorage.getItem(KEY) || "direto"; } catch { return "direto"; }
}
